{
  "access_denied_description": "Kontaktirajte administratore za više informacija",
  "access_denied_logout_btn": "Odjava",
  "access_denied_operator_label": "Operater",
  "access_denied_title": "Nema pristupa resursima trgovine",
  "bet_builder": "Bet Builder",
  "bet_details_header_event": "Događaj",
  "bet_details_header_market": "Market",
  "bet_details_header_odds": "Kvota",
  "bet_details_header_outcome": "Ishod",
  "bet_details_header_status": "Status",
  "bet_details_header_time": "Vrijeme",
  "bet_details_payment": "Uplata",
  "bet_details_payment_tax": "Porez na uplatu",
  "bet_details_possible_payout": "Moguća isplata",
  "bet_details_possible_winnings": "Mogući dobici",
  "bet_details_stake": "Ulog",
  "bet_details_tax_on_winnings": "Porez na dobitak",
  "bet_type_combo": "Kombinacija",
  "bet_type_multibet": "Multibet",
  "bet_type_single": "Jednostruka",
  "bet_type_system": "Sistem",
  "betslip_action_accepted": "Prihvaćen",
  "betslip_action_failed": "Neuspješan",
  "betslip_action_pending": "Na čekanju",
  "betslip_action_rejected": "Odbijen",
  "betslip_payin": "Uplata listića",
  "betslip_table_action": "Akcija",
  "betslip_table_amount": "Iznos",
  "betslip_table_game": "Igra",
  "betslip_table_id": "ID",
  "betslip_table_status": "Status",
  "betslip_table_time": "Vrijeme",
  "cash_register_balance_heading": "STANJE ({currency})",
  "cash_register_end_session_cash_to_leave_in_register": "Gotovina za ostaviti u blagajni",
  "cash_register_end_session_cash_transfer": "Prijenos gotovine",
  "cash_register_end_session_confirm": "Zatvori sesiju",
  "cash_register_end_session_confirm_modal_back": "Natrag",
  "cash_register_end_session_confirm_modal_message": "Jeste li sigurni da želite zatvoriti trenutnu sesiju?",
  "cash_register_end_session_confirm_modal_title": "Upozorenje",
  "cash_register_end_session_current_physical_cash_balance": "Trenutno fizičko stanje gotovine",
  "cash_register_end_session_keep_all_cash_in_register_heading": "Stanje ({currency})",
  "cash_register_end_session_keep_all_cash_in_register_option_label": "Ostavi sav novac u blagajni",
  "cash_register_end_session_keep_all_cash_in_register_title": "STANJE",
  "cash_register_end_session_note": "Napomena",
  "cash_register_end_session_register_balance": "Stanje blagajne",
  "cash_register_end_session_take_out_amount": "Iznos za podići",
  "cash_register_end_session_title": "Zatvori sesiju",
  "cash_register_end_session_transfer_type": "Vrsta prijenosa",
  "cash_register_end_session_transfer_type_bank": "Banka",
  "cash_register_end_session_transfer_type_cash": "Gotovina",
  "cash_register_make_transfer_amount_label": "Iznos",
  "cash_register_make_transfer_direction_label": "Smjer prijenosa",
  "cash_register_make_transfer_direction_take_in": "Uplata",
  "cash_register_make_transfer_direction_take_out": "Isplata (podizanje gotovine)",
  "cash_register_make_transfer_note_label": "Napomena",
  "cash_register_make_transfer_note_placeholder": "Unesite napomenu",
  "cash_register_make_transfer_submit_button": "Prenesi",
  "cash_register_make_transfer_title": "Izvrši prijenos",
  "cash_register_make_transfer_type_label": "Vrsta prijenosa",
  "cash_register_no_session_description": "Pokrenite novu sesiju da biste aktivirali blagajnu",
  "cash_register_no_session_title": "Nema aktivne sesije",
  "cash_register_session_details_balance": "Stanje",
  "cash_register_session_details_closed_at": "Zatvoreno u",
  "cash_register_session_details_closed_by": "Zatvorio",
  "cash_register_session_details_duration": "Trajanje",
  "cash_register_session_details_end_session_button": "Zatvori sesiju",
  "cash_register_session_details_id": "ID sesije",
  "cash_register_session_details_info_title": "Informacije o sesiji",
  "cash_register_session_details_make_transfer_button": "Izvrši prijenos",
  "cash_register_session_details_opened_at": "Otvoreno u",
  "cash_register_session_details_opened_by": "Otvorio",
  "cash_register_session_details_operators": "Operateri",
  "cash_register_session_details_opt_in_button": "Pridruži se",
  "cash_register_session_details_opted_in_button": "Pridružen",
  "cash_register_session_details_title": "Sesije",
  "cash_register_session_details_transactions": "Transakcije",
  "cash_register_session_details_transactions_credit_debit_card_balance": "Stanje kreditnih/debitnih kartica ({currency})",
  "cash_register_session_details_transactions_direct_deposits": "Direktni depoziti",
  "cash_register_session_details_transactions_physical_cash": "Fizička gotovina ({currency})",
  "cash_register_session_details_transactions_retail_location_withdrawals": "Podizanja na lokaciji",
  "cash_register_session_details_transactions_starting_cash_balance_cash_float": "Početno stanje gotovine (cash float)",
  "cash_register_session_details_transactions_title": "Transakcije sesije",
  "cash_register_session_details_transactions_total_balance": "Ukupno stanje ({currency})",
  "cash_register_session_details_transactions_voucher_issued": "Izdano",
  "cash_register_session_details_transactions_voucher_redeemed": "Iskorišten",
  "cash_register_session_details_transactions_voucher_revoked": "Opozvan",
  "cash_register_session_operators_popup_description": "Popis operatera uključenih u ovu sesiju",
  "cash_register_session_opt_in_failed": "Pridruživanje sesiji nije uspjelo!",
  "cash_register_start_session_failed": "Pokretanje sesije nije uspjelo!",
  "cash_register_start_session_info_notification": "Početno stanje gotovine određeno je prethodno zatvorenom sesijom. Stanje gotovine uvijek možete ispraviti radnjom „Izvrši prijenos”.",
  "cash_register_start_session_success": "Nova sesija je pokrenuta!",
  "cash_register_start_session_title": "Pokreni sesiju",
  "cash_register_starting_cash_balance": "Početno stanje gotovine",
  "common_all_info": "Sve informacije",
  "common_app_version": "Verzija aplikacije",
  "common_back": "Nazad na",
  "common_betshop": "Kladionica",
  "common_cancel": "Odustani",
  "common_company": "Tvrtka",
  "common_copy_all_info": "Kopiraj sve informacije",
  "common_currency": "Valuta",
  "common_deposits": "Depoziti",
  "common_device": "Uređaj",
  "common_device_uuid": "UUID uređaja",
  "common_direct_transfer": "Direktan prijenos",
  "common_error": "Došlo je do nepoznate pogreške. Molimo pokušajte ponovo",
  "common_games": "Igre",
  "common_info": "Informacije",
  "common_language": "Jezik",
  "common_load_more": "Učitaj više",
  "common_logout": "Odjava",
  "common_menu": "Izbornik",
  "common_operations": "Operacije",
  "common_payin": "Uplata",
  "common_payout": "Isplata",
  "common_plugins": "Plugini",
  "common_print": "Ispis",
  "common_products": "Proizvodi",
  "common_rebet": "Ponovno klađenje",
  "common_save": "Spremi",
  "common_services": "Usluge",
  "common_settings": "Postavke",
  "common_start_session": "Pokreni sesiju",
  "common_transfers": "Prijenosi",
  "common_unknown": "Nepoznato",
  "common_voucher": "Vaučer",
  "common_vouchers": "Vaučeri",
  "deposits_direct_deposit_create_error": "Kreiranje uplate nije uspjelo!",
  "deposits_direct_deposit_create_success": "{amount}{currency} uplaćeno igraču \"{playerNickname}\"",
  "deposits_direct_deposit_form_max_amount_validation_error": "Maksimalni iznos je {amount}",
  "deposits_direct_deposit_form_min_amount_validation_error": "Minimalni iznos je {amount}",
  "deposits_direct_deposit_form_player_label": "E-pošta ili nadimak igrača",
  "deposits_direct_deposit_form_player_not_found": "Igrač nije pronađen",
  "deposits_direct_deposit_form_submit_button": "Dalje",
  "deposits_direct_deposit_method_card": "Kartica",
  "deposits_direct_deposit_method_cash": "Gotovina",
  "deposits_direct_deposit_player_side_sheet_email": "E-pošta",
  "deposits_direct_deposit_player_side_sheet_full_name": "Puno ime",
  "deposits_direct_deposit_player_side_sheet_nickname": "Nadimak",
  "deposits_direct_deposit_player_side_sheet_verification_status": "Status verifikacije",
  "deposits_direct_deposit_print_failed": "Potvrda nije ispisana zbog greške pisača.",
  "deposits_direct_deposit_side_sheet_amount_label": "Iznos uplate",
  "deposits_direct_deposit_side_sheet_confirm_button": "Potvrdi uplatu",
  "deposits_direct_deposit_side_sheet_method_label": "Način uplate",
  "deposits_direct_deposit_side_sheet_title": "Izravna uplata",
  "deposits_direct_deposit_verification_status_fully_verified": "Potpuno verificiran",
  "deposits_direct_deposit_verification_status_not_verified": "Nije verificiran",
  "deposits_direct_deposit_verification_status_partially_verified": "Djelomično verificiran",
  "deposits_direct_deposits_no_session_notification": "Za depozit morate pokrenuti sesiju.",
  "deposits_direct_table_empty_description": "Nema depozita u posljednjih {timePeriod}.",
  "deposits_direct_table_empty_title": "Nema depozita",
  "deposits_direct_table_header_amount": "Iznos",
  "deposits_direct_table_header_id": "ID depozita",
  "deposits_direct_table_header_made_at": "Kreirano",
  "deposits_direct_table_time_period_label": "Vremensko razdoblje",
  "deposits_direct_table_title": "Posljednji depoziti",
  "deposits_direct_transfer_subtitle": "Kreirajte depozit i izravno uplati sredstva na račun igrača. Depoziti koje ste napravili navedeni su ispod.",
  "deposits_direct_transfer_title": "Napravi direktni depozit",
  "deposits_voucher_create_error": "Kreiranje vaučera neuspješno!",
  "deposits_voucher_create_success": "Vaučer kreiran.",
  "deposits_voucher_form_amount_label": "Iznos",
  "deposits_voucher_form_create_button": "Kreiraj",
  "deposits_voucher_form_max_amount_validation_error": "Maksimalni iznos je {amount}",
  "deposits_voucher_form_min_amount_validation_error": "Minimalni iznos je {amount}",
  "deposits_vouchers_subtitle": "Kreirajte vaučer koji igrači mogu koristiti kao način plaćanja. Vaučeri koje ste kreirali navedeni su ispod.",
  "deposits_vouchers_table_empty_description": "Nema kreiranih vaučera u posljednjih {timePeriod}.",
  "deposits_vouchers_table_empty_title": "Nema vaučera",
  "deposits_vouchers_table_header_created": "Kreirano",
  "deposits_vouchers_table_header_source": "Izvor",
  "deposits_vouchers_table_header_status": "Status",
  "deposits_vouchers_table_header_value": "Vrijednost",
  "deposits_vouchers_table_header_voucher_id": "ID vaučera",
  "deposits_vouchers_table_time_period_label": "Vremensko razdoblje",
  "deposits_vouchers_title": "Kreiraj vaučer",
  "info_tab_main_info": "Glavne informacije",
  "info_tab_working_time": "Radno vrijeme",
  "info_working_time_open": "Otvoreno",
  "info_working_time_closed": "Zatvoreno",
  "info_copy_to_clipboard_success": "{ title } kopiran u međuspremnik.",
  "keyboard_shortcuts_not_found": "Nema aktivnih prečaca za ovu kategoriju!",
  "login_operator_account_disabled_error_message": "Pristup odbijen. Račun je trenutačno onemogućen.",
  "login_operator_credentials_error_message": "Nevažeći podaci operatera",
  "login_operator_device_not_connected_error_message": "Pristup odbijen. Uređaj nije povezan.",
  "login_operator_max_concurrent_sessions_error_message": "Pristup odbijen. Dosegnuli ste najveći broj istovremenih sesija na uređajima. Odjavite se s drugog uređaja i pokušajte ponovno.",
  "login_operator_default_button_text": "Prijava",
  "login_operator_pass_label": "Lozinka",
  "login_operator_remember_username": "Zapamti korisničko ime",
  "login_operator_title": "Prijava operatera",
  "login_operator_unauthorized_location_error_message": "Pristup odbijen. Niste ovlašteni za prijavu s ove lokacije.",
  "login_operator_user_label": "Korisničko ime",
  "operator_logout": "Odjavljeni ste.",
  "operation_navigation_cash_register": "Blagajna",
  "operation_navigation_deposits": "Depoziti",
  "operation_navigation_keyboard_shortcuts": "Prečaci",
  "operation_navigation_reports": "Izvještaji",
  "operation_navigation_settings": "Postavke",
  "operation_navigation_withdrawal": "Isplate",
  "printer_action_perform_print_failed": "Radnja pisača nije uspjela. Molimo pokušajte ponovo.",
  "printer_action_perform_print_success": "Uspješno ispisano",
  "printer_action_refresh_success": "Popis PoS pisača osvježen",
  "printer_autocutter": "Automatski rezač",
  "printer_cover_open": "Poklopac pisača je otvoren",
  "printer_offline": "Printer je offline, provjerite papir i poklopac printera",
  "printer_paper_error_notification": "Nema više papira u printeru. Molimo pozovite svog operatera.",
  "printer_paper_low": "Nedostatak papira",
  "printer_paper_out": "Nema papira",
  "printer_paper_out_while_printing": "Nema papira dok se ispisuje",
  "settings_interface_language": "Jezik sučelja",
  "settings_last_tickets": "Posljednji listići",
  "settings_last_tickets_current_game": "Trenutna igra",
  "settings_last_tickets_games": "Prikaži listiće iz igara",
  "settings_last_tickets_games_placeholder": "Odaberi igre",
  "settings_last_tickets_number": "Broj listića za prikaz",
  "settings_last_tickets_number_placeholder": "Odaberi količinu",
  "settings_last_tickets_show_all": "Prikaži sve",
  "settings_modal_discard_changes": "Odbaci",
  "settings_modal_unsaved_changes_message": "Imate nespremljene promjene. Napuštanjem ove kartice odbacit ćete ih?",
  "settings_modal_unsaved_changes_title": "Upozorenje",
  "settings_print_a4_configuration": "Konfiguracija A4 pisača",
  "settings_print_a4_configuration_description": "Format papira A4",
  "settings_print_a4_test": "Test ispisa za A4 pisač",
  "settings_print_a4__test_modal_title": "Test ispisa",
  "settings_print_a4_title": "A4 pisač",
  "settings_print_configure": "Konfiguriraj",
  "settings_print_pos_configuration": "Konfiguracija PoS pisača",
  "settings_print_pos_configuration_description": "Konfiguracija izgleda ispisa",
  "settings_print_pos_configuration_label": "Odaberi konfiguraciju",
  "settings_print_pos_printer": "PoS pisač",
  "settings_print_pos_printer_label": "Odaberi PoS pisač",
  "settings_print_pos_test": "Test ispisa za PoS pisač",
  "settings_print_pos_title": "PoS pisač",
  "settings_print_test": "Test ispisa",
  "settings_printing_language": "Jezik ispisa",
  "settings_save_success": "Promjene spremljene",
  "slip_action_check": "Provjeri",
  "slip_action_print_copy": "Ispiši kopiju",
  "slip_action_rebet": "Ponovno klađenje",
  "slip_cancel_ticket": "Otkaži tiket",
  "slip_cancel_ticket_failed": "Otkazivanje tiketa nije uspjelo",
  "slip_check_details_bet_title": "Oklada {index}: {title}",
  "slip_check_details_betslip_id": "ID listića",
  "slip_check_error": "Neuspješna provjera listića.",
  "slip_check_modal_check_button": "Provjeri",
  "slip_check_modal_content": "Unesite ID tiketa ili skenirajte barkod za pregled detalja tiketa.",
  "slip_check_modal_ticket_id_label": "ID tiketa",
  "slip_check_modal_title": "Provjera tiketa",
  "slip_payin": "Uplata listića",
  "slip_payin_success": "Listić je uspješno uplaćen.",
  "slip_payout_betslip": "Isplata listića: {amount} {currency}",
  "slip_payout_failed": "Isplata nije uspjela",
  "slip_pending_action": "Pričekajte potvrdu listića.",
  "slip_print_copy": "Ispiši kopiju",
  "slip_print_copy_failed": "Ispis kopije nije uspio",
  "slip_print_failed": "Ispis listića nije uspio",
  "slip_print_payout_confirmation": "Ispiši potvrdu isplate",
  "slip_print_payout_confirmation_failed": "Ispis potvrde isplate nije uspio",
  "slip_rebet_failed": "Ponovno klađenje nije uspjelo",
  "slip_resolve_failed": "Neuspješno rješavanje listića",
  "slip_status_accepted": "Prihvaćen",
  "slip_status_failed": "Neuspješan",
  "slip_status_pending": "Na čekanju",
  "slip_status_rejected": "Odbijen",
  "slip_table_action": "Akcija",
  "slip_table_amount": "Iznos",
  "slip_table_game": "Igra",
  "slip_table_id": "ID",
  "slip_table_status": "Status",
  "slip_table_time": "Vrijeme",
  "time_period_last_24_hours": "Posljednjih 24 sata",
  "time_period_last_hour": "Posljednji sat",
  "voucher_details_footer_redeem": "Iskoristi vaučer",
  "voucher_details_footer_revoke": "Opozovi vaučer",
  "voucher_details_header_amount": "Iznos",
  "voucher_details_header_issued_in": "Izdano u",
  "voucher_details_header_redeemed_at": "Iskorišteno",
  "voucher_details_header_redeemed_in": "Iskorišteno u",
  "voucher_details_header_status_expired": "Istekao",
  "voucher_details_header_status_redeemed": "Iskorišten",
  "voucher_details_header_status_revoked": "Opozvan",
  "voucher_details_header_status_valid": "Vrijedi: {date}",
  "voucher_details_header_valid_until": "Vrijedi do",
  "voucher_print_failed": "Slanje vaučera na ispis nije uspjelo.",
  "voucher_print_success": "Vaučer je uspješno ispisan.",
  "voucher_redeem_failed": "Iskorištenje vaučera nije uspjelo.",
  "voucher_revoke_failed": "Opoziv vaučera nije uspio.",
  "voucher_revoke_success": "Vaučer je uspješno opozvan.",
  "widget_latest_betslips": "Posljednji listići",
  "widget_shortcuts_title": "Prečaci",
  "widget_shortcuts_all_shortcuts": "Svi prečaci",
  "widget_calculator": "Kalkulator",
  "calculator_transactions_title": "Transakcije",
  "calculator_session_tab": "Sesija {currency}",
  "calculator_table_title": "Tablica ({count})",
  "calculator_no_transactions": "Nema zabilježenih transakcija u trenutnoj sesiji kalkulatora.",
  "calculator_money_in": "Primljeni novac",
  "calculator_money_in_modal_title": "Primljeni novac",
  "calculator_payments": "Uplate",
  "calculator_payouts": "Isplate",
  "calculator_rest": "Ostatak",
  "calculator_give_to_player": "Dati igraču",
  "calculator_collect_from_player": "Naplatiti od igrača",
  "calculator_reset_session": "Resetiraj sesiju",
  "calculator_clear_session_currency": "Očisti {currency}",
  "calculator_pin_view": "Prikvači kalkulator",
  "calculator_full_screen": "Prošireni prikaz",
  "calculator_helper_tip": "Kad date gotovinu igraču, očistite kalkulator ili isključite tu transakciju iz dnevnika kako biste izbjegli greške.",
  "calculator_reset_session_title": "Resetiraj sesiju",
  "calculator_reset_session_message": "Jeste li sigurni da želite resetirati trenutnu sesiju?",
  "calculator_reset_session_confirm": "Resetiraj",
  "calculator_close": "Zatvori",
  "calculator_excluded_transactions_warning": "Ručno ste isključili {excluded}/{total} transakcija",
  "calculator_table_include": "Uključi",
  "calculator_table_item": "Stavka",
  "calculator_table_id": "ID",
  "calculator_table_time": "Vrijeme",
  "calculator_table_action": "Akcija",
  "calculator_table_amount": "Iznos (+/-)",
  "calculator_table_status": "Status",
  "calculator_action_betslip_payin": "Uplata listića",
  "calculator_action_betslip_payout": "Isplata listića",
  "calculator_action_betslip_cancel": "Storno listića",
  "calculator_action_betslip_cashout": "Cashout listića",
  "calculator_action_voucher_create": "Izdavanje vaučera",
  "calculator_action_voucher_redeem": "Iskorištenje vaučera",
  "calculator_status_pending": "U tijeku",
  "calculator_status_success": "Uspjeh",
  "calculator_status_fail": "Neuspjeh",
  "calculator_status_reject": "Odbijeno",
  "working_hours_off": "Location working hours are currently off. Next opening: {datetime}."
}
